import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-payment-terms-dialog',
  templateUrl: './payment-terms-dialog.component.html',
  styleUrls: ['./payment-terms-dialog.component.scss']
})
export class PaymentTermsDialogComponent {
  isActivePaymentTerms:string= '';
  constructor(@Inject(MAT_DIALOG_DATA) public data: {isActivePaymentTerms: string},private dialogRef: MatDialogRef<PaymentTermsDialogComponent>){
    this.isActivePaymentTerms = this.data.isActivePaymentTerms
  }

  close(isTrue:boolean){
    this.dialogRef.close(isTrue);
  }
}
